import { render, staticRenderFns } from "./InfinityScroll.vue?vue&type=template&id=4923b2d8&scoped=true"
import script from "./InfinityScroll.vue?vue&type=script&lang=js"
export * from "./InfinityScroll.vue?vue&type=script&lang=js"
import style0 from "./InfinityScroll.vue?vue&type=style&index=0&id=4923b2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923b2d8",
  null
  
)

export default component.exports